/**
 * รายการเมนูที่ปิดใช้งานสำหรับ LH Bank (LHB)
 * ---------------------------------------------------------------------------
 * ที่มา : เอกสารประชุม LHB วันที่ 1 กันยายน 2569
 *         `LHB-Navbar-Menu-DEV-TAX-ปิดเมนู.md` (Navbar active 103 รายการ)
 * ขอบเขต: เริ่มต้น 47 รายการ = 19 รายการที่ Mark [X] โดยตรง + 28 รายการลูกที่ปิดตามหัวข้อแม่
 *         ปัจจุบันเหลือ 42 รายการ หลังย้าย TaxDashboard / TaxPlanningMobileConfigurations /
 *         TaxConsent ไปอยู่ใต้กลุ่ม Tax Planning V2 ที่ยังเปิดใช้งาน (ตามที่ตกลงวันที่ 3 ก.ย. 2569)
 *         และเปิดคืน SettingExternalConnector / SetupSocial (7 ก.ย. 2569)
 *
 * วิธีแก้ไข
 *   - เพิ่มเมนูที่ต้องการปิด  : เพิ่ม key เข้า CLOSED_MENU_KEYS
 *   - เปิดเมนูคืน            : ลบ key ออก (หรือ comment บรรทัดนั้นไว้)
 *   - key คือค่า `href` ใน items[] ของ NavBar.vue ซึ่งตรงกับ `name` ของ route ใน router.js
 *
 * ผลของการใส่ key
 *   1. เมนูหายจาก Navbar (NavBar.vue กรอง items[] ตามรายการนี้)
 *   2. เข้า URL ตรงไม่ได้ ถูกส่งไปหน้า AccessDenied (router.js ตรวจใน beforeEach)
 *   3. route ลูกที่ไม่ได้อยู่ในรายการก็ถูกปิดด้วย ถ้าแม่ของมันถูกปิด
 *      (router.js ไล่ตามสายแม่-ลูกใน childToParent ให้อัตโนมัติ
 *       เช่น ปิด 'TaxPlanning' จะครอบถึง TaxSandbox / TaxConfigurationEdit ด้วย)
 *
 * หมายเหตุ: การปิดที่นี่เป็นการปิดฝั่ง frontend ไฟล์ของหน้าที่ปิดยังถูกรวมอยู่ใน build
 *           การถอดออกจาก bundle ทั้งหมดเป็นงานแยกที่ยังไม่ได้ทำ
 */

/** เมนูที่ปิดใช้งาน — เรียงตามลำดับในเอกสาร (ย่อหน้าตามชั้นของเมนู) */
export const CLOSED_MENU_KEYS = [
  'dashboard',                       // แดชบอร์ด
    'VectorManagement',              // เอกสาร
      'UploadVector',                // การจัดการเอกสาร  // ปิดตามหัวข้อแม่
    'UploadSoundToDocument',         // Upload Sound To Document
      'UploadSoundToDocumentDetail', // Generate Question Set  // ปิดตามหัวข้อแม่
    'ProductGroup',                  // ผลิตภัณฑ์
      'ProductDetail',               // รายละเอียดผลิตภัณฑ์  // ปิดตามหัวข้อแม่
  'ToolManagement',                  // การจัดการเครื่องมือ
  'IntentGroup',                     // Intent
    'IntentSession',                 // Intent Session  // ปิดตามหัวข้อแม่
      'IntentSessionDetail',         // Intent Session Detail  // ปิดตามหัวข้อแม่
  'Replace',                         // เทคนิคการเพิ่มประสิทธิภาพ (หัวข้อกลุ่ม)
    'GroupPromptTemplate',           // Prompt Template  // ปิดตามหัวข้อแม่
      'PromptTemplate',              // Prompt Template Detail  // ปิดตามหัวข้อแม่
    'GroupReplacetext',              // การแทนที่ข้อความ  // ปิดตามหัวข้อแม่
      'ReplaceText',                 // Add Text Group  // ปิดตามหัวข้อแม่
  'Validation',                      // การทดสอบโมเดล (หัวข้อกลุ่ม)
    'ValidationGenerate',            // สร้างคำถามทดสอบ  // ปิดตามหัวข้อแม่
      'ValidationGenerateUpload',    // Generate Question Set  // ปิดตามหัวข้อแม่
    'ValidationPositive',            // ชุดคำถามเชิงบวก  // ปิดตามหัวข้อแม่
      'ValidationPositiveDetail',    // Upload Positive Question Set  // ปิดตามหัวข้อแม่
    'ValidationNegative',            // ชุดคำถามเชิงลบ  // ปิดตามหัวข้อแม่
      'ValidationNegativeDetail',    // อัปโหลดชุดคำถามเชิงลบ  // ปิดตามหัวข้อแม่
    'ValidationProcess',             // ดำเนินการทดสอบ  // ปิดตามหัวข้อแม่
      'DashboardScore',              // Dashboard score  // ปิดตามหัวข้อแม่
    'UserChatManagement',            // การจัดการผู้ใช้แชท
    'GroupUserManagement',           // Group User Management
      'UserGroupDetail',             // User Group Detail  // ปิดตามหัวข้อแม่
        'SetupUserGroup',            // Setup User Group  // ปิดตามหัวข้อแม่
  'ChatManagement',                  // การจัดการแชท (หัวข้อกลุ่ม)
    'SetupGroupModel',               // การจัดกลุ่มโมเดล  // ปิดตามหัวข้อแม่
    'ModelShortcut',                 // โมเดลชอร์ตคัท  // ปิดตามหัวข้อแม่
    'ModelQuickReply',               // Model Quick Reply  // ปิดตามหัวข้อแม่
    'ShortcutMenu',                  // Shortcut menu  // ปิดตามหัวข้อแม่
    // เปิดเมนูคืนตามที่ทีมแจ้ง (7 ก.ย. 2569) — ถ้าต้องการปิดอีกครั้ง ให้เอา comment ออก
    // 'SettingExternalConnector',   // การเชื่อมต่อภายนอก
    // 'SetupSocial',                // การเชื่อมต่อแพลตฟอร์ม
    'ServiceTheme',                  // ตั้งค่าธีม
    'ConsentConfig',                 // การกำหนดความยินยอม
  'TaxPlanning',                     // Tax Planning (หัวข้อกลุ่ม)
    'TaxConfiguration',              // Tax Configuration  // ปิดตามหัวข้อแม่ — V2 มี TaxConfigurationV2 แทนแล้ว
    'TaxHistory',                    // Tax History  // ปิดตามหัวข้อแม่ — V2 มี TaxHistoryV2 แทนแล้ว
    // TaxDashboard / TaxPlanningMobileConfigurations / TaxConsent ไม่อยู่ในรายการปิดแล้ว
    // เพราะย้ายไปอยู่ใต้กลุ่ม Tax Planning V2 ที่ยังเปิดใช้งาน (V2 ยังไม่มีเมนูเทียบเท่า)
    // ถ้าต้องการปิดทั้งสามหน้าจริง ให้เพิ่ม key กลับเข้ามาที่นี่
    'ReportQuestionTop10',           // แนวโน้มคำถาม
    'ReportFeedback',                // Report Feedback
  'Playground',                      // แชท เพลย์กราวด์คู่
];

/**
 * หน้าที่ "ไม่ให้ปิดตามหัวข้อแม่" — ถึงแม่จะอยู่ใน CLOSED_MENU_KEYS ก็ยังเข้าได้
 *
 * ใช้กับหน้าลูกที่ไม่ได้ถูก Mark ปิดในเอกสาร LHB แต่บังเอิญมีแม่อยู่ในสาย
 * childToParent ของ router.js จึงถูก isRouteClosed() ไล่สายไปปิดตามโดยไม่ตั้งใจ
 *
 * ตัวอย่าง: 'DocumentControl' (จัดการองค์ความรู้ของ vector) เป็นลูกของ
 * 'VectorManagement' ที่ถูกปิด แต่ยังต้องเข้าได้ เพราะปุ่ม Manage Knowledge
 * ในหน้า 'MetaDoc' (เมตาเอกสาร — ยังเปิดใช้งาน) เป็นทางเข้าเดียวของหน้านี้
 *
 * ⚠️ ยกเว้นเฉพาะการปิด "ตามแม่" เท่านั้น — ถ้าใส่ key ลง CLOSED_MENU_KEYS ตรง ๆ
 *    ด้วย จะถือว่าปิด (รายการปิดโดยตรงชนะรายการยกเว้น)
 */
export const CLOSURE_EXEMPT_KEYS = [
  'DocumentControl',                 // จัดการองค์ความรู้ — เข้าจากปุ่มในหน้า MetaDoc
];

const CLOSED_SET = new Set(CLOSED_MENU_KEYS);
const EXEMPT_SET = new Set(CLOSURE_EXEMPT_KEYS);

/**
 * หน้าปลายทางหลังเข้าสู่ระบบ และปลายทางของการกดโลโก้
 * เดิมคือ 'dashboard' ซึ่งถูกปิดตามเอกสาร จึงเปลี่ยนมาที่ LHBDashboard
 *
 * ⚠️ ต้องตรวจสอบสิทธิ์ก่อนใช้งานจริง: ขณะนี้ 'LHBDashboard' มีอยู่ใน
 *    SuperAdminRights (roleId 0) และ adminRights (roleId 1) เท่านั้น
 *    generalUsersRights (roleId 2) และ operatorRights (roleId 6) ยังไม่มีสิทธิ์นี้
 *    ถ้าไม่แก้ ผู้ใช้สองกลุ่มนั้นจะเจอหน้า AccessDenied ทันทีหลังเข้าสู่ระบบ
 *    เลือกทางใดทางหนึ่ง:
 *      (ก) เพิ่ม 'LHBDashboard' เข้า rights ของ role ที่ต้องการ (router.js + NavBar.vue)
 *      (ข) กำหนดปลายทางแยกตาม role ที่ LANDING_ROUTE_BY_ROLE ด้านล่าง
 */
export const DEFAULT_LANDING_ROUTE = 'LHBDashboard';

/**
 * ปลายทางเฉพาะราย role — ใช้เมื่อบาง role ไม่มีสิทธิ์เข้า DEFAULT_LANDING_ROUTE
 * key คือ roleId (0 = Super admin, 1 = Admin, 2 = User, 6 = Operator)
 *
 * ค่าที่ตั้งไว้เลือกจาก "หน้าที่ role นั้นมีสิทธิ์อยู่แล้วและไม่ได้ถูกปิด"
 * เพื่อไม่ให้ต้องขยายสิทธิ์เพิ่มในงานนี้ ปรับได้ตามที่ทีมต้องการ
 */
export const LANDING_ROUTE_BY_ROLE = {
  // User: เดิมหลังเข้าสู่ระบบไปที่ /VectorManagement ซึ่งถูกปิดตามเอกสาร
  // 'MetaDoc' (เมตาเอกสาร) อยู่ใน generalUsersRights และไม่ได้ถูกปิด
  2: 'MetaDoc',
  // Operator: คงพฤติกรรมเดิม /ChatService ซึ่งไม่ได้ถูกปิด
  6: 'ChatService',
};

/** ปลายทางหลังเข้าสู่ระบบของ role ที่ระบุ */
export function getLandingRoute(roleId) {
  const key = String(roleId);
  return LANDING_ROUTE_BY_ROLE[key] || DEFAULT_LANDING_ROUTE;
}

/** เมนู/route นี้ถูกปิดโดยตรงหรือไม่ (ไม่ไล่ตามสายแม่-ลูก) */
export function isMenuClosed(key) {
  return CLOSED_SET.has(key);
}

/**
 * route นี้ได้รับการยกเว้นจากการปิดตามหัวข้อแม่หรือไม่
 * (ถ้าถูกปิดโดยตรงใน CLOSED_MENU_KEYS ยังถือว่าปิด)
 */
export function isClosureExempt(key) {
  return EXEMPT_SET.has(key) && !CLOSED_SET.has(key);
}
